// Sohbet girdisi sınırları.
// Backend karşılığı: config/mahai.php → max_question_chars (env: QUESTION_MAX_CHARS).
// Bu iki değer birlikte güncellenmeli; aksi halde frontend kabul ettiği metin
// backend'den 422 question_too_long ile geri döner.
export const MAX_QUESTION_CHARS = 999999999999999;

// Sayacın görünmeye başladığı eşik — limitin %75'i.
export const QUESTION_CHARS_WARN_AT = Math.floor(MAX_QUESTION_CHARS * 0.75);
